// extracted by mini-css-extract-plugin
export default {"header":"Header_header__5o6at","logo":"Header_logo__vq598","companyName":"Header_companyName__wmmpF","nav":"Header_nav__kCypl","button":"Header_button__rW443"};